// app/question/test.js

(function () {
    "use strict";
    var controllerId = "StakTest";
    angular.module("app").controller(controllerId, ["$rootScope", "$scope", "$filter", "$location", "common", "bootstrap.dialog", "$routeParams", "$q", "$uibModal", "datacontext", "sectionMenu", "filterFilter", "$translate", "amMoment", 'moment', 'tmhDynamicLocale', StakTest]);

    function StakTest($rootScope, $scope, $filter, $location, common, bDialog, $routeParams, $q, $uibModal, datacontext, sectionMenu, filterFilter, $translate, amMoment, moment, tmhDynamicLocale) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, "logError");
        var logSuccess = getLogFn(controllerId, "logSuccess");
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard
        var vm = this;
        vm.title = "Test";
        vm.view = "list";       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);
        vm.goBack = goBack;

        vm.objName = "test"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;
        vm.preview = 0;
        vm.setPreview = function (index) { vm.preview = index; };

        vm.importDisabled = false;
        vm.exportDisabled = false;
        vm.addDisabled = false;

        if (!$rootScope.bOperatore || $rootScope.bAmministratore) {
            vm.importDisabled = true;
            vm.addDisabled = true;
        }

        vm.addTitle = 'NuovoTest';
        //vm.readonly = false;
        vm.readonly = true;
        
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        vm.difficolta = [{ Id: 1, Name: 'Facile' }, { Id: 2, Name: 'Facile/Medio' }, { Id: 3, Name: 'Medio' }, { Id: 4, Name: 'Medio/Alto' }, { Id: 5, Name: 'Alto' }, { Id: 6, Name: 'Estremo' }];
        vm.numeroPacchetti = [{ 'id': 5, 'name': $translate.instant('Da1A5') }, { 'id': 15, 'name': $translate.instant('Da6A15') }, { 'id': 16, 'name': $translate.instant('PiuDi15') }];
        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ["Difficolta'", "Materia", "Titolo", "Ultima Modifica"];
        vm.list.materie = [];
        vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[3];
        
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            cerca();
        };
        if (!$rootScope.bOperatore && !$rootScope.bAmministratore) {
            vm.stato = [{ 'id': 3, 'name': $translate.instant('Pubblicato') }, { 'id': 4, 'name': $translate.instant('Rifiutato') }];
        }
        else
            vm.stato = [{ 'id': 1, 'name': $translate.instant('InLavorazione') }, { 'id': 3, 'name': $translate.instant('Pubblicato') }, { 'id': 4, 'name': $translate.instant('Rifiutato') }];

        //Elenchi dettaglio
        vm.list.questions = [];
        vm.list.pacchetti = [];
        vm.getRecord = getRecord;
        vm.getListQuestions = getListQuestions;
        vm.getListPacchetti = getListPacchetti;

        //Elenco anteprime
        vm.list.anteprime = [];
        vm.getListAnteprime = getListAnteprime;
        vm.list.licenze = [];

        //Filtro
        vm.filter = {};
        vm.filter.testo = "";
        vm.filter.stato = 0;
        vm.filter.numeroPacchetti = 0;
        vm.fTesto = "";
        vm.fStato = 0; 
        vm.fNumeroPacchetti = 0;

        //Elenco per finestra modale di Create
        vm.materie = [];
        vm.tipoTest = [];
        vm.pacchettoId = 0;

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        vm.importQuestion = importQuestion;
        vm.import = loadModal;
        vm.deleteQuestion = deleteQuestion;
        vm.get = getRecord;
        vm.add = addModal;
        vm.update = updateItem;
        vm.delete = deleteItem;
        vm.pubblica = pubblica;
        vm.modifica = modifica;
        vm.getMaterie = getMaterie;
        vm.setMateriaId = setMateriaId;
        vm.toggleRisposte = toggleRisposte;
        vm.ricalcolaAnteprime = ricalcolaAnteprime;

        vm.rifiuta = false;
        vm.reject = reject;
        vm.rifiutoPopup = rifiutoPopup;

        //datapicker
        vm.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened = !vm.opened;
        };

        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        vm.currentLanguage = $translate.proposedLanguage() || $translate.use();
        amMoment.changeLocale(vm.currentLanguage);
        tmhDynamicLocale.set(vm.currentLanguage);

        if (vm.currentLanguage == "en") {
            vm.data = 'MM/dd/yyyy HH:mm';
        } else if (vm.currentLanguage == "it") {
            vm.data = 'dd/MM/yyyy HH:mm';
        }

        vm.format = 'dd/MM/yyyy';
        vm.stampaTest = stampaTest;
       
        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getListLicenze(), getTipoTest()];
            common.activateController(promises, controllerId)
                .then(function () {
                    if ($routeParams.testId != null) {
                        setView("detail");
                        vm.pacchettoId = ($routeParams.pacchettoId != null) ? $routeParams.pacchettoId : 0;

                        if (vm.pacchettoId != 0)
                            vm.sectionMenu = sectionMenu.setSection("Pacchetti");

                        getRecord($routeParams.testId, 0);
                    }
                });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {            
            if (view == 'list') {                
                cerca();
            }
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.stato = vm.fStato == null ? 0 : vm.fStato;
            vm.filter.testo = vm.fTesto == null ? 0 : vm.fTesto;
            vm.filter.data = vm.fData == null ? '' : $filter('date')(vm.fData, vm.format);
            vm.filter.numeroPacchetti = vm.fNumeroPacchetti == null ? 0 : vm.fNumeroPacchetti;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.stak_test_countByFilter(vm.filter.testo, vm.filter.stato, vm.filter.numeroPacchetti, vm.filter.data)
                .then(function (data) {
                    if (data) {
                        vm.countRecords = data;
                    }
                });
        }

        function getAllByFilter() {            
            if (vm.loading === true) return;
            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;
            vm.loading = true;
            return datacontext.stak_test_getAllByFilter(vm.pageSize, vm.page, vm.filter.testo, vm.filter.stato, vm.filter.numeroPacchetti, vm.filter.data, vm.ordine.value)
                .then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;                    
                });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {            
            return datacontext.stak_test_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;
                vm.record.data = $filter("date")(data.DtUpdate, "dd/MM/yyyy");
                vm.record.status = $filter("teststatus")(data.status);
                //Azzera liste
                vm.list.anteprime = [];               
                getListAnteprime(id);

                //Azzera liste
                vm.list.questions = [];
                vm.list.pacchetti = [];
                vm.newWord = '';
                vm.preview = 0;
                countListQuestions(id);
                countListPacchetti(id);
                gestisciBottoni();
                setView("detail");
            });
        }

        function goBack() {
            if (vm.pacchettoId == 0)
                setView('list');
            else
                $location.url("/pacchetto/" + vm.pacchettoId);
        }

        function gestisciBottoni() {
            vm.readonly = true;
            if (vm.record.statusCode == 1) {
                vm.readonly = false;
                vm.rifiuto = false;
            }
            if (vm.record.statusCode == 3) 
                vm.readonly = true;
            if (vm.record.statusCode == 4) {
                vm.rifiuto = true;
            }
            

            if (!$rootScope.bOperatore && !$rootScope.bAmministratore) {
                vm.rifiuta = true;
                vm.rifiuto = false;
            }
            if (vm.record.statusCode == 4) {
                vm.rifiuta = false;
            }

            if ($rootScope.bAmministratore) {
                vm.readonly = true;
            }
        }

        function pubblica() {
            vm.record.note = "";
            return datacontext.stak_test_pubblica(vm.record).then(function (data) {
                if (data && data != null && data.Id > 0) {
                    logSuccess($translate.instant('TestPubblicato'));
                    vm.record.statusCode = data.statusCode;                    
                    vm.record.status = $filter("teststatus")(data.status);
                    vm.record.data = $filter("date")(data.DtUpdate, "dd/MM/yyyy");
                    gestisciBottoni();
                }
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }

        function modifica() {
            return datacontext.stak_test_modifica(vm.record).then(function (data) {
                if (data && data != null && data.Id > 0) {
                    logSuccess($translate.instant('PossibileModificareTest'));
                    vm.record.statusCode = data.statusCode;
                    vm.record.status = $filter("teststatus")(data.status);
                    vm.record.data = $filter("date")(data.DtUpdate, "dd/MM/yyyy");
                    gestisciBottoni();
                }
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }

        function addRecord(id) {
            return datacontext.stak_test_get(id).then(function (data) {
                if (data && data != null && data.Id > 0) {
                    vm.records.push(data);
                    vm.countRecords++;
                }
                else
                    logError($translate.instant('ErroreCreazione'));
            });
        }

        function updateItem() {
            if (vm.record.tipoTestId == null)
                vm.record.tipoTestId = 0;

            return datacontext.stak_test_update(vm.record).then(function (data) {
                if (data && data != null && data.Id > 0) {
                    //getListAnteprime(vm.record.Id);//x far visualizzare le immagini                    
                    logSuccess($translate.instant('DatoSalvato'));
                    vm.newWord = '';
                    vm.record.tags = data.tags;
                }
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }        

        function deleteItem(item) {
            var msg = " Test " + item.title + " ";
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.stak_test_delete(item.Id).then(function (data) {
                    if (data == "404") return logError($translate.instant('ErroreRimozione'));
                    else if (data == "409") return logError($translate.instant('ImpossibileEliminareTestVenduto'));
                    else if (data == "200") {
                        var index = vm.records.indexOf(item);
                        vm.records.splice(index, 1);
                        vm.countRecords--;
                    }
                });
            });
        }

        //List Methods
        function getListLicenze() { //sfruttando la funzione getAllList del datacontext otteniamo id e nome della lista di materie
            return datacontext.licenza_getAll().then(function (data) { //datacontext.materia_getAllList
                return vm.list.licenze = data;
            });
        }

        function getListAnteprime(id) {
            if (!id) return;
            return datacontext.testAnteprime_getAllByTest(id, 0).then(function (data) {
                if (data && data.length > 0) {
                    data.sort(function (a, b) {
                        return a.sequence - b.sequence;
                    });

                    data.forEach(function (q) {
                        q.qPath = q.Path;
                        q.rPath = q.PathRisposta;
                        q.showRisposta = false;
                    });
                }
                return vm.list.anteprime = data;
            });
        }

        //List Methods
        function getListQuestions(id) {
            if (!id) return;
            return datacontext.stak_questionTest_getAllByTest(id, "sequence").then(function (data) {
                return vm.list.questions = data;
            });
        }

        function countListQuestions(id) {
            if (!id) return;
            return datacontext.stak_questionTest_countAllByTest(id).then(function (data) {
                return vm.countQuestions = data;
            });
        }

        function getListPacchetti(id) {
            if (!id) return;
            return datacontext.testPacchetti_getAllByTest(id, "titolo").then(function (data) {
                return vm.list.pacchetti = data;
            });
        }

        function countListPacchetti(id) {
            if (!id) return;
            return datacontext.testPacchetti_countAllByTest(id).then(function (data) {
                return vm.countPacchetti = data;
            });
        }

        //Elenchi Parametri
        function getQuestionsNotInTest() {
            return datacontext.stak_question_getAllListNotInTest(vm.record.Id).then(function (data) {
                return vm.questions = data;
            });
        }

        function getTipoTest() {
            return datacontext.tipoTest_getAllList().then(function (data) {
                return vm.tipoTest = data;
            });
        }

        //Metodi di delete object List
        function deleteQuestion(item) {
            var title = (item.questionText != null) ? item.questionText : item.questionImgName;
            var msg = " " + $translate.instant('Domanda') + ": " + title;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.stak_questionTest_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('ErroreRimozione'));

                    //getListAnteprime(item.testId);
                    var index = vm.list.questions.indexOf(item);
                    var sequence = item.sequence;
                    vm.list.questions.splice(index, 1);
                    vm.countQuestions--;
                    vm.list.questions.forEach(function (obj) {
                        if (obj.sequence > sequence)
                            obj.sequence = obj.sequence - 1;
                    });
                    updateSequence();//aggiunto per aggiornare anteprime
                });
            });
        }

        //Metodi interfaccia 
        function changeSequence(orderList, testId) {
            datacontext.stak_questionTest_changeSequence(orderList).then(function (data) {
                if (!data) {
                    getListAnteprime(testId);                    
                }
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }

        function updateSequence() {
            if (vm.readonly == true)
                return;

            var orderList = [];
            //var orderListAnteprime = [];
            var sequence = 1;
            var testId ='';

            vm.list.questions.forEach(function (item) {
                item.sequence = sequence++;
                orderList.push(item.Id);
                //if(item.sequence <= 6)
                //    orderListAnteprime.push(item.questionId);
                testId= item.testId;
                
            });
            changeSequence(orderList, testId);
        }

        vm.sortingLog = [];

        vm.sortableOptions = {
            handle: "> .myHandle",
            update: function (e, ui) {
                var logEntry = vm.list.questions.map(function (i) {
                    return i.value;
                }).join(", ");
                vm.sortingLog.push("Update: " + logEntry);
            },
            stop: function (e, ui) {
                // this callback has the changed model
                var logEntry = vm.list.questions.map(function (i) {
                    return i.value;
                }).join(", ");
                vm.sortingLog.push("Stop: " + logEntry);
                updateSequence();

            }
        };

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            var stakeholders = [];
            var stakeholderId = null;

            var materie = [];
            var materiaId = null;

            var stakeholder = {};
            stakeholder.Id = $rootScope.id;
            stakeholder.RagioneSociale = $rootScope.name;
            stakeholders = [stakeholder];
            stakeholderId = $rootScope.id;
            materie = vm.materie;
            

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/STAK_Test/modal/testAdd.html",
                controller: "stakTestAdd",
                resolve: {
                    stakeholders: function () {
                        return stakeholders;
                    },
                    stakeholderId: function () {
                        return stakeholderId;
                    },
                    materie: function () {
                        return materie;
                    },
                    materiaId: function () {
                        return materiaId;    //materiaId non impostato - da selezionare in inserimento
                    },
                    tipoTest: function () {
                        return vm.tipoTest;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('ErroreCreazione'));

                logSuccess($translate.instant('DatoSalvato'));
                return $q.when(addRecord(returnItem.Id)).then(function () {
                    vm.get(returnItem.Id, vm.countRecords - 1);
                });

            });
        }

        // Question
        function importQuestion() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/STAK_Test/modal/questionTestAdd.html",
                controller: "stakQuestionTestAdd",
                resolve: {
                    testId: function () {
                        return vm.record.Id;    //testId impostata con record visualizzato
                    },
                    testSourceId: function () {
                        return null;    //testSourceId impostata con record visualizzato
                    },
                    questions: function () {
                        return null;
                    },
                    questionId: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                getListQuestions(vm.record.Id);
                logSuccess($translate.instant('DatoSalvato'));
            });
        }
        //Import da File
        function loadModal() {
            //var record = { Id: vm.record.Id, Name: vm.record.Username };

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/STAK_Question/modal/domandaLoad.html',
                controller: 'stakDomandaLoad',
                resolve: {
                    testId: function () {
                        return 0;
                    },
                    tipoTest: function () {
                        return vm.tipoTest;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('ImpossibileSalvareDati'));
                cerca().then(function () {
                    var i = _.findIndex(vm.records, function (v) { return Math.max(v.Id) });
                    getRecord(vm.records[i].Id, 0);
                });
                logSuccess($translate.instant('TestImportato'));
            });
        }

        function getMaterie(ricerca) {
            vm.record.materia = ricerca;
            return datacontext.materia_getAll(0, 0, ricerca).then(function (data) {
                if (Array.isArray(data) && data.length > 0) {
                    vm.list.materie = data;
                    return vm.list.materie;
                }
                return null;
            });
        }

        function setMateriaId(materia) {
            vm.record.materiaId = materia.Id;
            vm.record.materia = materia.Titolo;
        }

        function toggleRisposte(item) {            
            item.showRisposta = !item.showRisposta;

            if (item.showRisposta)
                item.Path = item.rPath;
            else 
                item.Path = item.qPath;            
        }

        function stampaTest(testId) {
            if (!testId)
                testId = vm.record.Id;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/STAK_Test/modal/stampaTest.html?version=43",
                controller: "stampaTestStak",
                windowClass: 'modal-wide-print',
                resolve: {
                    testId: function () {
                        return testId;
                    }
                }
            });
        }

        function ricalcolaAnteprime() {
            datacontext.stak_test_ricalcolaAnteprime(vm.record.Id).then(function (data) {
                if (!data) {
                    getListAnteprime(vm.record.Id);
                    logSuccess($translate.instant('DatoSalvato'));
                }                    
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }

        function reject() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/STAK_Test/modal/rifiutoPopup.html?version=43',
                controller: 'stakRifiutoPopup',
                resolve: {
                    test: function () {
                        return vm.record;
                    },
                    readOnly: function () {
                        return 'false';
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                return datacontext.stak_test_reject(returnItem).then(function (data) {
                    if (data && data != null && data.Id > 0) {
                        logSuccess($translate.instant('TestRifiutato'));
                        vm.record.statusCode = data.statusCode;
                        vm.record.status = $filter('teststatus')(data.status);
                        vm.record.data = $filter('date')(data.DtUpdate, 'dd/MM/yyyy');
                        gestisciBottoni();
                    }
                    else
                        logError($translate.instant('ImpossibileSalvareDati'));
                });
            });
        }

        function rifiutoPopup() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/STAK_Test/modal/rifiutoPopup.html?version=43',
                controller: 'stakRifiutoPopup',
                resolve: {
                    test: function () {
                        return vm.record;
                    },
                    readOnly: function () {
                        return 'true';
                    }
                }
            });
            modalInstance.result.then(function (returnItem) {
                if (returnItem == true)
                    modifica();
            });
        }
    }
})();
